import "./menu.scss"
import {HashLink} from 'react-router-hash-link'
type MenuType = {
    menuOpen : boolean;
    setMenuOpen(flag:boolean):void;
};

export default function Menu({menuOpen, setMenuOpen}:MenuType) {
    return (
        <div className={"sidebar " + (menuOpen && "active")}>
            <ul>
                <li onClick = {()=> setMenuOpen(false)} className = {"menuItem1 " + (menuOpen && "active")}>
                    <HashLink to="/#home">Home</HashLink>
                </li>
                <li onClick = {()=> setMenuOpen(false)} className = {"menuItem2 " + (menuOpen && "active")}>
                <HashLink to="/#about" smooth>About</HashLink>
                </li>
                <li onClick = {()=> setMenuOpen(false)} className = {"menuItem3 " + (menuOpen && "active")}>
                <HashLink to="/#volunteer" smooth>Volunteer</HashLink>
                </li>
                <li onClick = {()=> setMenuOpen(false)} className = {"menuItem4 " + (menuOpen && "active")}>
                    <HashLink to="/#causes" smooth>Causes</HashLink>
                </li>
                <li onClick = {()=> setMenuOpen(false)} className = {"menuItem5 " + (menuOpen && "active")}>
                <HashLink to="/#blog" smooth>Blog</HashLink>
                </li>
                <li onClick = {()=> setMenuOpen(false)} className = {"menuItem6 " + (menuOpen && "active")}>
                <HashLink to="/#contact" smooth>Contact</HashLink>
                </li>
            </ul>
        </div>
    )
}

